import {ofType} from 'redux-observable'
import {ajax} from 'rxjs/ajax';
import {EMPTY, of} from 'rxjs';
import i18next from 'i18next';
import {catchError, map, mergeMap, switchMap} from 'rxjs/operators'

import {
    LOG_IN_REQUEST_START,
    logInRequestFail,
    logInRequestSuccess,
    LOGOUT_REQUEST_START, LOGOUT_REQUEST_SUCCESS,
    logoutRequestFail,
    logoutRequestSuccess,
} from '../actions/Auth'
import {SHOPS_SELECT_SHOP, shopsClearData} from "../actions/Shops";
import {eventsSetUserId} from "../Components/utils";
import {setWsConnected} from "../actions/Chats";
import {deletePushToken, registerPushToken} from "../thunks/Users";


export const logInRequestEpic = (action$, state$) =>
    action$.pipe(
        ofType(LOG_IN_REQUEST_START),
        mergeMap(
            action => ajax.post(
                process.env.REACT_APP_API_URL + 'auth/login/',
                {
                    "email": action.email,
                    "password": action.password,
                },
                {
                    'Content-Type': 'application/json',
                }).pipe(
                map(response => {
                    if (response.response.status === 'ok') {
                        eventsSetUserId(response.response.result.user.id);
                        return logInRequestSuccess(response.response.result.token, response.response.result.user)
                    } else {
                        return logInRequestFail(response.response.errors)
                    }
                }),
                catchError(error => {
                    return of(logInRequestFail({
                        'common': i18next.t('errors.common.request_sent', 'Error sending request')
                    }));
                })
            )
        )
    );


export const logOutEpic = (action$, state$) =>
    action$.pipe(
        ofType(LOGOUT_REQUEST_START),
        map(() => {
            deletePushToken();
            eventsSetUserId(null);
            localStorage.removeItem('activeShop');
            return logoutRequestSuccess();
        }),
    );

export const logoutFromNats = (action$, state$) =>
    action$.pipe(
        ofType(LOGOUT_REQUEST_SUCCESS),
        map(()=>{
            state$.value.Plugins.nats.terminate();
            return setWsConnected(false)
        })
    );


export const setGlobalUserData = (action$, state$) =>
    action$.pipe(
        ofType(SHOPS_SELECT_SHOP),
        switchMap(
            () => {
                //
                // window.s2bUserID = state$.value.Auth.user.id;
                // window.s2bUserEmail = state$.value.Auth.user.email;
                //
                // // Set Yandex metrika data
                // if (window.ym && window.yandexMetrikaID) {
                //     window.ym(window.yandexMetrikaID, 'userParams', {
                //         UserID: state$.value.Auth.user.id,
                //         UserEmail: state$.value.Auth.user.email,
                //     });
                // }

                return EMPTY;
            }
        )
    );
